<template>
  <div class="container">
    <template v-if="verify">
      <div class="title">输入交易密码，完成身份验证</div>
      <!-- 密码输入框 -->
      <van-password-input :value="value" :focused="showKeyboard" />
      <div class="forgetPwd" @click="forgetPwd">忘记密码?</div>
    </template>
    <template v-else>
      <div class="title">设置6位交易密码</div>
      <!-- 密码输入框 -->
      <van-password-input
        :value="realValue"
        :focused="showKeyboard"
        @focus="showKeyboard = true"
      />
      <van-button :class="active ? 'active' : ''" @click="btnOk"
        >完成</van-button
      >
    </template>
    <!-- 数字键盘 -->
    <template v-if="verify">
      <van-number-keyboard v-model="value" :show="showKeyboard" />
    </template>
    <template v-else>
      <van-number-keyboard v-model="realValue" :show="showKeyboard" />
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: "",
      showKeyboard: true,
      verify: true,
      realValue: "",
    };
  },
  computed: {
    active() {
      return this.realValue.length === 6;
    },
  },
  watch: {
    value(value) {
      if (value.length === 6) {
        this.checkPassword(value);
      }
    },
  },
  created() {
    this.verify = this.$route.query.set ? false : true;
  },
  methods: {
    checkPassword(value) {
      this.$http
        .request(this.$http.pathMap.checkPassword, "post", { password: value })
        .then((res) => {
          this.verify = false;
        })
        .catch((err) => {
          this.value = "";
          this.showKeyboard = true;
        });
    },
    updatePassword(value) {
      this.$http
        .request(this.$http.pathMap.updatePassword, "post", { password: value })
        .then((res) => {
          this.$router.back();
        });
    },
    btnOk() {
      if (this.realValue.length === 6) {
        this.updatePassword(this.realValue);
      }
    },
    forgetPwd() {
      this.$router.push("/pages/user/forgetPwd");
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 50px;
  .title {
    margin: 0 auto 20px;
    text-align: center;
  }
  .forgetPwd {
    text-align: end;
    font-size: 14px;
    margin-right: 17px;
    color: $uni-text-color-grey;
  }
  .van-button {
    width: 313px;
    margin: 0 30px;
    background: #eee;
  }
  .active {
    background: $base-color;
    color: #fff;
  }
}
</style>
